import api from './api'

export const platformSettingsService = {
  // Get platform settings (super admin only)
  async getSettings() {
    try {
      const response = await api.get('/platform/settings')
      return response.data
    } catch (error) {
      console.error('Error getting platform settings:', error)
      throw error
    }
  },

  // Get the platform-wide enabled languages (public, no auth) (#206)
  async getEnabledLanguages() {
    const response = await api.get('/public/enabled-languages')
    return response.data?.enabledLanguages || []
  },

  // Update platform settings (super admin only)
  async updateSettings(settings) {
    try {
      const response = await api.put('/platform/settings', settings)
      return response.data
    } catch (error) {
      console.error('Error updating platform settings:', error)
      throw error
    }
  },

  // Get support configuration (super admin only)
  async getSupportConfig() {
    try {
      const response = await api.get('/platform/support-config')
      return response.data
    } catch (error) {
      console.error('Error getting support config:', error)
      throw error
    }
  },

  // Update support configuration (super admin only)
  async updateSupportConfig(config) {
    try {
      const response = await api.put('/platform/support-config', config)
      return response.data
    } catch (error) {
      console.error('Error updating support config:', error)
      throw error
    }
  }
}

export default platformSettingsService
